import { CommentBubbleIcon } from '@m/alchemy-ui/icons/CommentBubbleIcon';
import * as Styled from './IdeaCard.styled';

interface IdeaCommentCountProps {
  readonly count: number;
}

export const IdeaCommentCount = ({ count }: IdeaCommentCountProps) => (
  <Styled.CommentLink>
    <Styled.CommentIcon>
      <CommentBubbleIcon aria-hidden="true" />
    </Styled.CommentIcon>
    <span>{count}</span>
  </Styled.CommentLink>
);
